import { ConditionsSheetsClient } from '@src/orders/services/ConditionsSheetsClient';
import { ConditionSheets } from '@src/permits/completePermit/fields/ConditionSheets';
import { useQuery } from '@tanstack/react-query';

export const useListConditionsSheets = () => {
  const { data, isLoading } = useQuery({
    queryKey: ['ConditionsSheets.list'],
    queryFn: () => ConditionsSheetsClient.list(),
  });

  return { conditionsSheets: data ?? new ConditionSheets([]), isLoading };
};
